import { useClientContext } from "../../../hooks/ClientContext";
import { useFetchAmlSectionQuery, useRemoveAmlEvidenceMutation } from "../../../services/clientfactfind";
import useNotes from "./useNotes";

export const useAntiMoneyLaundering = () => {
    const { id: masterAccountId } = useClientContext();

    const { data, isLoading, isFetching, isError, error, refetch } = useFetchAmlSectionQuery({ masterAccountId });
    const [removeTrigger, { isLoading: isRemovingEvidence }] = useRemoveAmlEvidenceMutation();
    const removeEvidence = (evidenceId) => removeTrigger({ masterAccountId, evidenceId }).unwrap();

    const {
        clientStatuses, evidence, isValid, status, notesId, notes
    } = data ?? {};

    const { updateNotes } = useNotes();

    const patchAmlNotes = (newNotes) => updateNotes(notesId, newNotes);

    return {
        isLoading,
        isFetching,
        isError,
        error,
        refetch,
        clientStatuses,
        evidence,
        amlStatus: status,
        notes,
        patchAmlNotes,
        isValid,
        removeEvidence,
        isRemovingEvidence,
    };
};
